export default __webpack_public_path__ + "static/media/ChartOfMonth.ae3b0dcb.JPG";